<template>
  <div class="ml-5 mr-5">
    <div
      v-bind:class="{ errorShake: isErrorShake }"
      class="mt-6 mb-5"
      style="max-width: 600px; background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 30px; margin: 0 auto; box-shadow: 0 0 10px rgb(150, 150, 150)"
    >
      <a @click="adminPage">Admin Home</a>
      <span class="ml-1 mr-1">></span>
      <a @click="ordersPage">Orders</a>
      <span class="ml-1 mr-1">></span>

      <a>Edit Order</a>

      <h1 class="text-center mb-4">Edit Order</h1>
      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>

      <v-form ref="form">
        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Email"
            required
            v-model="email"
          ></v-text-field>
        </div>

        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Name"
            required
            v-model="name"
          ></v-text-field>
        </div>

        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Address 1"
            required
            v-model="address1"
          ></v-text-field>
        </div>

        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Address 2"
            v-model="address2"
          ></v-text-field>
        </div>

        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="City"
            required
            v-model="city"
          ></v-text-field>
        </div>

        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="State"
            required
            v-model="state"
          ></v-text-field>
        </div>

        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-text-field
            background-color="white"
            color="success"
            height="40"
            label="Zipcode"
            required
            v-model="zipcode"
          ></v-text-field>
        </div>

        <div
          class="mb-4"
          style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
        >
          <v-textarea
            background-color="white"
            color="success"
            label="Notes"
            multiline
            v-model="notes"
          ></v-textarea>
        </div>

        <div style="display: flex;">
          <span class="mr-2 mt-1">Shipped:</span>
          <v-checkbox v-model="shipped" style="padding: 5px; margin: 0px;"></v-checkbox>
        </div>

        <div style="display: flex;">
          <span class="mr-2 mt-1">Refunded:</span>
          <v-checkbox v-model="refunded" style="padding: 5px; margin: 0px;"></v-checkbox>
        </div>

        <div style="width: 60%; margin: 0 auto;">
          <v-btn
            class="mb-2"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="50"
            color="success"
            @click="updateOrder"
          >Update Order</v-btn>
        </div>
      </v-form>
    </div>
    <div style="max-width: 800px; margin: 0 auto">
      <div v-for="item in this.purchasedItems" :key="item.itemID">
        <h3>{{item.title}}</h3>
        <v-row no-gutters>
          <v-col cols="12" sm="3">
            <p>Kind: {{item.kind}}</p>
          </v-col>
          <v-col cols="12" sm="3">
            <p>Size: {{item.size}}</p>
          </v-col>
          <v-col cols="12" sm="3">
            <p>Quantity: {{item.quantity}}</p>
          </v-col>
          <v-col cols="12" sm="3">
            <p>Dollar Amount: ${{item.dollarAmount}}</p>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/AdminService";

export default {
  data: () => ({
    error: "",
    order: null,
    message: "",
    id: "",
    email: "",
    name: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipcode: "",
    notes: "",
    purchasedItems: null,
    shipped: "",
    refunded: "",
    total: ""
  }),
  async mounted() {
    try {
      const response = await AdminService.admin();
    } catch (error) {
      // Credentials failed. Logout user and instruct them to login
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.error = error.response.data.error;
    }
    let itemsList = JSON.parse(this.$store.state.selectedOrder.purchasedItems);
    this.id = this.$store.state.selectedOrder.id;
    this.email = this.$store.state.selectedOrder.email;
    this.name = this.$store.state.selectedOrder.name;
    this.address1 = this.$store.state.selectedOrder.address1;
    this.address2 = this.$store.state.selectedOrder.address2;
    this.city = this.$store.state.selectedOrder.city;
    this.state = this.$store.state.selectedOrder.state;
    this.zipcode = this.$store.state.selectedOrder.zipcode;
    this.notes = this.$store.state.selectedOrder.notes;
    this.purchasedItems = itemsList;
    this.shipped = this.$store.state.selectedOrder.shipped;
    this.refunded = this.$store.state.selectedOrder.refunded;
    this.total = this.$store.state.selectedOrder.total;
  },
  methods: {
    adminPage() {
      this.$router.push("/admin");
    },
    ordersPage() {
      this.$router.push("/adminOrders");
    },
    async updateOrder() {
      try {
        let orderUpdating = {
          id: this.id,
          email: this.email,
          name: this.name,
          address1: this.address1,
          address2: this.address2,
          city: this.city,
          state: this.state,
          zipcode: this.zipcode,
          notes: this.notes,
          shipped: this.shipped,
          refunded: this.refunded
        };
        const response = await AdminService.updateOrder(orderUpdating);
        this.$router.push("/adminOrders");
      } catch (error) {
        this.error = error.response.data.error;
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      }
    }
  }
};
</script>
